import { Button } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Drawing from '/@/components/drawing';
import Icon from '/@/components/icon';
import Splash from '/@/components/splash';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { axFetch, setUser } from '/@/store/session/actions';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const emailVerified = () => {
    const history = useNavigate();
    const { token } = useParams();
    const [error, setError] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const dispatch = useDispatch();

    const verifyUser = async () => {
        try {
            await axFetch.get(`${settings.urls.users.verifyAccount}/${token}`);
            const res = await axFetch.get(settings.urls.users.profile);
            dispatch(setUser(res.data));
        } catch (err) {
            setError(true);
        }
        setLoaded(true);
        setTimeout(() => {
            history('/');
        }, 5000);
    };

    useEffect(() => {
        verifyUser();
    }, []);

    return (
        <Splash stretch verifiedView>
            <div className={styles.box}>
                <Drawing type={error ? 'error' : 'success-corn'} size='lg' />
                <div className={styles.text}>
                    <Button variant='contained' sx={{ mt: 2 }} onClick={() => history('/')}>
                        {_('Ir al inicio')}
                    </Button>
                    {loaded ? (
                        <Fragment>
                            {!error ? (
                                <Fragment>
                                    <Icon type='sent' size='xl' />
                                    <Title className={styles.title} bold>
                                        {_('Tu email fue verificado correctamente')}
                                    </Title>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Icon type='notSent' size='xl' />
                                    <Title className={styles.title} bold>
                                        {_('Ha ocurrido un error al verificar tu email')}
                                    </Title>
                                </Fragment>
                            )}
                        </Fragment>
                    ) : null}
                </div>
            </div>
        </Splash>
    );
};

export default emailVerified;
